var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDyteIntegration)?_c('dyte-video-call',{attrs:{"message-id":_vm.messageId,"meeting-data":_vm.contentAttributes.data}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }